import { writable } from 'svelte/store';

// Create a global store for loader state
export const globalLoaderStore = writable({
  isVisible: false,
  text: 'Loading...',
  overlay: true,
  spinner: true,
  progress: 0
});

export interface LoaderState {
  isVisible: boolean;
  text: string;
  overlay: boolean;
  spinner: boolean;
  progress: number;
}
